import React, { useState } from "react";
import loginvactor from "../../assets/svg/login-vactor.svg";
import Forgot from "../../assets/svg/forgot-password.svg";
import confirmVactor from "../../assets/svg/confirm-password.svg";
import topVactor from "../../assets/svg/top-shape.svg";
import bottomVactor from "../../assets/svg/bottom-shape.svg";
import getworkLogo from "../../assets/svg/partner-logo.svg";
import getworkBottomLogo from "../../assets/png/new_powered_gw.png";
import LoginForm from "../form/login/LoginForm";
import ForgotPassword from "../form/login/ForgotPassword";
import CreatePassword from "../form/login/CreatePassword";
import SignUpForm from "../form/login/SignUpForm";
import SignUpVactor from "../../assets/svg/sign-up-vactor.svg";

function LoginSection() {
  const [step, setStep] = useState(1);

  function getForm() {
    switch (step) {
      case 1:
        return <LoginForm setStep={setStep} />;
      case 2:
        return <ForgotPassword setStep={setStep} />;
      case 3:
        return <CreatePassword setStep={setStep} />;
      case 4:
        return <SignUpForm setStep={setStep} />;
      default:
        return <LoginForm setStep={setStep} />;
    }
  }

  function fetchImg(step) {
    return step === 1
      ? loginvactor
      : step === 2
      ? Forgot
      : step === 3
      ? confirmVactor
      : step === 4
      ? SignUpVactor
      : "";
  }

  return (
    <div className="fixed w-full h-screen flex items-start">
      <div className=" relative w-[55%] bg-[#fafafa] h-full flex flex-col aliggn items-center justify-center ">
        <div className="absolute top-0 left-0">
          <img src={topVactor} alt="top-vactor" />
        </div>

        <img
          src={fetchImg(step)}
          alt="logo"
          className="w-4/6 aspect-3/2 object-contain "
        />
        <div className="absolute bottom-0 right-0">
          <img src={bottomVactor} alt="top-vactor" />
        </div>
      </div>

      <div className="relative w-[45%] h-full  flex flex-col  items-center p-2 scroll-smooth overflow-y-auto hide-scrollbar">
        <img
          src={getworkLogo}
          alt="getwork-logo"
          className="w-[90px] aspect-3/2 object-contain pt-10 "
        />
        <h1 className="mt-6 text-3xl normal-case  ">
          {step === 1
            ? "Welcome back !"
            : step === 2
            ? "Forword Password"
            : step === 3
            ? "Create new password"
            : step === 4
            ? "Get Started Now"
            : ""}
        </h1>
        <p className="text-center text-gray-600 mt-3 text-sm pl-[15%] pr-[15%]">
          {step === 1 ? (
            "A dedicated partner in the job hunt, paving the path to professional success"
          ) : step === 2 ? (
            <>
              {"Don’t worry we got you"}
              <br /> {"Enter the Email address associate with your account."}
            </>
          ) : step === 3 ? (
            "Your new password must be different from previous used passwords"
          ) : step === 4 ? (
            "Building Stronger Alliances - Join Our Partner Network"
          ) : (
            ""
          )}
        </p>

        {getForm()}

        <div className="w-full sticky bottom-1 top-[100%] flex items-center justify-center">
          {/* <p className="text-sm ">Powered by</p>{" "} */}
          <img
            src={getworkBottomLogo}
            className=" w-[20%] aspect-auto object-contain  "
            alt="bootom-getwork-logo"
          />
        </div>
      </div>
    </div>
  );
}

export default LoginSection;
